import * as React from 'react';
import { DataGroup } from '../../../../components/data-group/DataGroup';
import { DataGroupPoint } from '../../../../components/data-group/DataGroupPoint';
import { TimeZoneAbbreviations } from '../../../../components/utility/timezones';
import { toLongDateTimeNoSeconds } from '../../../../utils/date-utils';
import { StartShipmentAction } from '../../../models/shipments/shipment-action';

interface IProps {
    originStop: StartShipmentAction;
}

export const ActionContentRouteStart = (props : IProps) => {

    return <div>
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="stop-panel-title">Route Origin</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">

                        <DataGroup title="">

                            {
                                props.originStop.address
                                    ? <DataGroupPoint
                                        label="Address"
                                        value={ `${ props.originStop.address.addressLine1 }
                                            ${props.originStop.address.city}, 
                                            ${props.originStop.address.stateProvince} 
                                            ${props.originStop.address.postalCode}`} 
                                    />
                                    : null
                            }
                            
                            {
                                props.originStop.actionTime
                                    ? <DataGroupPoint
                                        label="Shipment Time"
                                        value={ `${ toLongDateTimeNoSeconds(props.originStop.actionTime.local) } ${ TimeZoneAbbreviations[props.originStop.actionTime.timeZone] }` } />
                                    : null
                            }
                            
                            <DataGroupPoint
                                label="Name"
                                value={props.originStop.name} />
                        </DataGroup>

                    </div>
                </div>
            </div>;
};
